module.exports = __webpack_public_path__ + "media/images/nav-bar-icons-fa6f9297f2191b4f9c5adb14c657528d.svg";